export default "__VITE_ASSET__DZa4Jq1g__"